import { combineReducers } from "redux";

import { _blank } from "./_blank";
import _default from "./_default";

export default combineReducers({
    _blank,
    _default,
})